import { useCallback, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LoadingErrorHint } from '$components/loading-error-hint/loading-error-hint';
import { DeleteReportConfirmWrapper } from '$features/report-hub/components/delete-report-confirm-wrapper';
import { useDownloadReport } from '$features/report-hub/report-hub.api';
import { RunRecordDetail } from '$features/report-hub/run-record/run-record-detail';
import { useGetRunRecordReport } from '$features/report-hub/run-record/run-record-detail.api';

export function RunRecordDetailWrap() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const reportId = searchParams.get('id');
  const { data: report, isLoading } = useGetRunRecordReport(reportId);
  const downloadReportMutation = useDownloadReport();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleDownload = useCallback(async () => {
    if (!reportId) return;
    try {
      const downloadUrl = await downloadReportMutation.mutateAsync(reportId);
      window.open(downloadUrl, '_blank');
    } catch {
      // Errors surface through the mutation's status; nothing to do here.
    }
  }, [downloadReportMutation, reportId]);

  const handleDeleteSuccess = useCallback(() => {
    navigate({ search: '' });
  }, [navigate]);

  if (!report) {
    return isLoading ? null : <LoadingErrorHint className="m-top-xl" />;
  }

  return (
    <>
      <RunRecordDetail
        report={report}
        onDelete={() => setIsDeleteDialogOpen(true)}
        onDownload={handleDownload}
        isDownloading={downloadReportMutation.isPending}
      />
      <DeleteReportConfirmWrapper
        isDeleteConfirmOpen={isDeleteDialogOpen}
        onOpenChange={setIsDeleteDialogOpen}
        selectedReport={report}
        onDeleteSuccess={handleDeleteSuccess}
      />
    </>
  );
}
